interface RecordsIconProps {
    className?: string
}

export default function RecordsIcon({className}: RecordsIconProps) {
    return (
        <svg xmlnsXlink="http://www.w3.org/1999/xlink"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 48 48"
             fill="none"
             className={className ?? 'h-5 w-5'}
        >
            <rect width="48" height="48" fill="none" fillOpacity="0.01"/>
            <path d="M48 0H0V48H48V0Z" fill="none" fillOpacity="0.01"/>
            <path d="M16 35L10 41L4 35" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13L10 7L4 13" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 7V41" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M44 9H22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M36 19H22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M44 29H22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M36 39H22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
